module.exports = __webpack_public_path__ + "static/img/banner5.0ad8b7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner5.png
// module id = z4Ej
// module chunks = 6